import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({
      to: '/$locale/smartbanking/dashboard',
      params: { locale: 'cs' },
    })
  },
})
